import { Component, OnInit, Input, forwardRef, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { MaterialConfiguration } from 'app/core/components/workflow-new/material/configurations/material-configuration';
import { Observable } from 'rxjs/Observable';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { CardPresentationComponent } from 'app/core/components/workflow-new/common/card-presentation';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { emit } from 'cluster';

@Component({
  selector: 'itpx-deliverable-tile-uptodate',
  templateUrl: './deliverable-tile-uptodate.component.html',
  styleUrls: ['../../common/style.css', './deliverable-tile-uptodate.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CardPresentationComponent, useExisting: forwardRef(() => DeliverableTileUptodateComponent) }],
})
export class DeliverableTileUptodateComponent extends CardPresentationComponent implements OnInit {

  @Input('props') properties: { props: any, conf: MaterialConfiguration };
  @Input() state$: Observable<any>;
  @Output() triggerParent = new EventEmitter<any>();
  private sharedState$: Observable<any>;
  private tagType: string;
  private expired: boolean;
  private supplements: string;
  private imageWidth: string;
  private imageHeight: string;
  private cardHeight: string;
  private cardWidth: string;
  private thumbnail: string;
  private props: any;
  public conf: MaterialConfiguration;
  private readonly downloadableMaterial: string[] = ['ebook', 'ispring', 'archive'];
  private completedCourses: number;
  private completedContents: number;
  private totalCourses: number = 1;
  show = false;
  end: number;
  showEllipsis: boolean;
  readonly cutoffLimit = 90;

  constructor() {
    super();
  }

  ngOnInit() {
    this.sharedState$ = this.state$.shareReplay(1);
    Object.assign(this, this.properties);
    Object.assign(this, this.conf);
    this.update(this.props, true);
    this.props.showMarkCompleteButton = this.conf.classType !== 'AI Proctored Online Exam' && this.conf.classType !== 'Online Exam' && this.props.contents && this.props.contents.length && this.props.contents[0].showCompletionButton;
    this.completedCourses = this.props.contents && this.props.contents[0] && +this.props.contents[0].coursePercentage === 100 ? 1 : 0;
    this.completedContents = this.props.contents && this.props.contents.filter(content => content.completed).length;
    const descriptionLength = this.props.contents && this.props.contents[0] && this.props.contents[0].description ? this.props.contents[0].description.length : 0;
    this.showEllipsis = descriptionLength > this.cutoffLimit;
    this.end = Math.min(descriptionLength, this.cutoffLimit);
    this.sharedState$.bindToLifecycle(this).subscribe(res => {
      if (this.conf.classType !== 'Online Exam' && this.conf.classType !== 'AI Proctored Online Exam' && this.conf.classType !== 'Exam'){
        this.conf.clickable = res.enabled;
      }
      if (this.downloadableMaterial.includes(res.type.toLowerCase()) && res.googleEmbedLink)
        this.conf.links[0].url = [res.googleEmbedLink];
      // this.conf.target = [res.googleEmbedLink]
    });
  }

  isExternalMaterial(type: string): boolean {
    return type === 'external-ebook' || type === 'external-podcast'
      || type === 'external-eLearning' || type === 'external-presentation'
      || type === 'external-video' || type === 'external-article' || type === 'external-lab';
  }

  isOnlineMaterial(type: string): boolean {
    return type === 'scormcloud' || type === 'scorm' || type === 'video'
      || type === 'googleslides' || type === 'scorm-content' || type === 'presentation';
  }

  update(deliverable: any, createTarget: boolean) {
    if (this.isExternalMaterial(deliverable.type)) {
      this.conf.links[0]['id'] = this.props.contents[0].id;
      return;
    }
    if (!deliverable.contents || !this.isOnlineMaterial(deliverable.contents[0].type.configKey || deliverable.contents[0].type)) {
      return;
    }
    //TODO: name can be null ???
    // this.name = deliverable.name || 'Learning Material';
    if (createTarget && (deliverable.type === 'scormcloud')) {
      this.conf.target = [deliverable.type, deliverable.contents[0].registrationId, deliverable.contents[0].id];
    } else if (createTarget) {
      this.conf.target = [deliverable.type, deliverable.contents[0].id];
    }
    this.conf.action = LinkActions.REDIRECT;
    this.conf.links[0].url = this.conf.target;
  }

  onShowClicked(event: any) {
    this.show = !this.show;
    this.end = this.show ? this.props.contents[0].description.length : Math.min(this.props.contents[0].description.length, this.cutoffLimit);
    event.stopPropagation();
  }

  onTriggerParent(event: any) {
    this.completedContents = event.completedContentCount;
    this.triggerParent.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/deliverable-tile-uptodate/deliverable-tile-uptodate.component.ts